import axios from 'axios'
import { extractData } from '@/utils'
import { dataEntryUrls } from '@/api/urls'

const headers = { headers: {'Content-Type': 'application/json'}, withCredentials: true }

const trySetValue = (userId, managerId, rowIndex, columnIndex, data) => {
  return axios.post(dataEntryUrls.trySetValue(userId, managerId, rowIndex, columnIndex), JSON.stringify(data), headers)
    .then(extractData)
}

const insertRow = (userId, managerId, rowIndex) => {
  return axios.post(dataEntryUrls.insertRow(userId, managerId, rowIndex), JSON.stringify(''), headers)
}

const clearCell = (userId, managerId, { selectedCol, selectedRow }) => {
  const data = {
    Type: 'Cell',
    ColumnIndex: selectedCol,
    RowIndex: selectedRow
  }
  return axios.post(dataEntryUrls.clearCells(userId, managerId), data, headers)
    .then(extractData)
}

const clearCells = (userId, managerId, { selectedCol, selectedRow, selectedColumns, selectedRows }) => {
  const data = {
    Type: 'Many_Cell',
    ColumnIndex: selectedCol,
    RowIndex: selectedRow,
    selectedColumns,
    selectedRows
  }
  return axios.post(dataEntryUrls.clearCells(userId, managerId), data, headers)
    .then(extractData)
}

const editCell = async ({userId, managerId, rowIndex, columnIndex, data}) => {
  let report = await trySetValue(userId, managerId, rowIndex, columnIndex, data)
  if (report.Success) {
    return report.NewCellValue
  } else {
    const err = new Error(report.Error)
    err.response = { status: 422, data: { value: report.NewCellValue } }
    throw err
  }
}

export default {
  trySetValue,
  insertRow,
  clearCell,
  clearCells,
  editCell
}
